import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { Camambert, DownloadChart } from '../models/camambert.model';
import { Observable } from 'rxjs/Observable';
import Api from '../../common/services/api.service';


@Injectable()
export class DownloadChartService {

  constructor(private api: Api) { }

  //Nombre de connexion mensulle
  getCamambert(): Observable<Camambert[]> {
    return this.api.get("statistiques/connexioncamembert")
  }

  //Moyenne connexion journaliere
  getMoyenneConnexion(): Observable<Number> {
    return this.api.get("statistiques/moyenconnexion");
  }

  //Nombre de telechargement
  getDownloaded(): Observable<Number> {
    return this.api.get("statistiques/download");
  }

  //Nombre de telechargement par annee
  getDownloadedByYear(): Observable<DownloadChart[]> {
    return this.api.get("statistiques/downloadchart");
  }

    //Nombre de telechargement par annee
    countSouscripteur(): Observable<Number> {
      return this.api.get("souscripteurs/count");
    }

}



// WEBPACK FOOTER //
// ./src/app/admin-app/services/download-chart.service.ts